import { c as _c } from "react/compiler-runtime";
import type { FulfillmentMethod } from '../lib';
import './set-up-autoship.scss';
const IMMEDIATE_TITLES: Record<FulfillmentMethod, string> = {
  bopis: 'Pick up today',
  sdd: 'Delivered today',
  sth: 'Delivered in 1-3 days'
};
type SetUpAutoshipImmediateTitleProps = Readonly<{
  fulfillmentMethod: FulfillmentMethod;
  storeName?: string;
}>;
export const SetUpAutoshipImmediateTitle = t0 => {
  const $ = _c(5);
  const {
    fulfillmentMethod,
    storeName
  } = t0;
  const title = IMMEDIATE_TITLES[fulfillmentMethod];
  if (fulfillmentMethod === "bopis" && storeName) {
    let t1;
    if ($[0] !== storeName) {
      t1 = <span className="set-up-autoship__store-name">at {storeName}</span>;
      $[0] = storeName;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1 || $[3] !== title) {
      t2 = <span>{title} {t1}</span>;
      $[2] = t1;
      $[3] = title;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  return title;
};